<template>
    <div class="select-role-wrapper">
        <div class="tip-text">请选择您的角色</div>
        <div @click="roleClick(1)"
            class="role-item visitor-role">
            访客
        </div>
        <div @click="roleClick(2)"
            class="role-item teacher-role">教职工</div>
        <div @click="roleClick(4)"
            class="role-item free-bind">学生</div>
        <!-- <hua-button
            style="width: 180px;margin-top: 100px;"
              round
              block
              type="primary"
              @click="roleClick(3)"
          >解除绑定手机号
          </hua-button
          > -->
    </div>
</template>

<script>
    export default {
        data() {
            return {
                // isDisabled: false,
            }
        },
        created() {
            // localStorage.setItem('u_phone', '')
            localStorage.setItem('pageName', '') // 防止下次点击教职工直接进了邀约页面
        },
        methods: {
            roleClick(flag) {
                //flag === 1是访客，2是教职工,3是解除绑定
                this.$emit('roleSelect', flag)
            }
        }
    }
</script>

<style lang="less" scoped>
    .select-role-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: calc(100% - 60px);
        overflow: auto;
        padding-top: 160px;
        background-color: #ffffff;
        box-sizing: border-box;
        .tip-text {
            text-align: center;
            margin-bottom: 20px;
        }
        .role-item {
            box-sizing: border-box;
            padding-left: 100px;
            margin-bottom: 30px;
            width: 260px;
            height: 60px;
            line-height: 60px;
            font-weight: 700;
            font-size: 20px;
            color: #ffffff;
        }
        .visitor-role {
            background: url('../../image/bg_toInSchool.png');
            background-size: 100% 100%;
            letter-spacing: 56px;
        }
        .teacher-role {
            background: url('../../image/bg_toTeacherInvite.png');
            background-size: 100% 100%;
            letter-spacing: 18px;
        }
        .free-bind {
            background: url('../../image/bg_toInvite.png');
            background-size: 100% 100%;
            letter-spacing: 56px;
        }
    }
</style>